import React, { Fragment } from 'react';
import styleFactory from './cta-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var CtaCard = _ref => {
  var _ref$startElement = _ref.startElement,
    startElement = _ref$startElement === void 0 ? ___EmotionJSX("div", null) : _ref$startElement,
    title = _ref.title,
    subtitle = _ref.subtitle,
    className = _ref.className,
    _ref$endElement = _ref.endElement,
    endElement = _ref$endElement === void 0 ? ___EmotionJSX("div", null) : _ref$endElement,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'horizontal' : _ref$appearance;
  var styles = styleFactory(appearance);
  return ___EmotionJSX("div", {
    css: styles.container,
    className: className
  }, ___EmotionJSX(Fragment, null, startElement), ___EmotionJSX("div", {
    css: styles.content
  }, ___EmotionJSX("div", {
    css: styles.text
  }, title && ___EmotionJSX("div", {
    css: styles.title
  }, title), subtitle && ___EmotionJSX("div", {
    css: styles.subtitle
  }, subtitle)), ___EmotionJSX(Fragment, null, endElement)));
};
export default CtaCard;